import React, { useState } from "react";
import * as R from "ramda";
import styled from "styled-components";
import { Collapse, Icon } from "antd";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";

import PaymentSlider from "../../controls/PaymentSlider";
import {
  purchaseTest,
  FETCH_COMPANY_PURCHASES_LITE
} from "../../../store/actions/purchases";
import { FETCH_TESTS } from "../../../store/actions/catalogs";

import EnglishTest from "./EnglishTest";
import HumanTest from "./HumanTest";
import ExternalTest from "./ExternalTest";
import SocialStyle from "./SocialStyle";
import IvoTest from "./IvoTest";
import TypingTest from "./TypingTest";
import SuccessProbabilityTest from "./SuccessProbabilityTest";
import ReliabilityTest from "./ReliabilityTest";

const PaymentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Panel = Collapse.Panel;

const testResultRenderer = {
  "terman-armstrong": ExternalTest,
  "inteligenciaEmocional-armstrong": ExternalTest,
  "estiloTrabajo-armstrong": ExternalTest,
  "lateralidadCerebral-armstrong": ExternalTest,
  "cleaver-armstrong": ExternalTest,
  "comunicacionLaboral-armstrong": ExternalTest,
  "capacidadEducativa-armstrong": ExternalTest,
  "adaptabilidadSocial-armstrong": ExternalTest,
  "psicoAtento-armstrong": ExternalTest,
  "psicometrica-armstrong": ExternalTest,
  "escuchaActiva-armstrong": ExternalTest,
  "computacion-armstrong": ExternalTest,
  "lenguajeSeguros-armstrong": ExternalTest,
  "lenguajeIngles-armstrong": ExternalTest,
  "lenguajeIngles2-armstrong": ExternalTest,
  "asesorTelefonico-armstrong": ExternalTest,
  "epe-armstrong": ExternalTest,
  "ort1-armstrong": ExternalTest,
  "pceng1-armstrong": ExternalTest,
  "pcesp1-armstrong": ExternalTest,

  "terman-khor": ExternalTest,
  "inteligenciaEmocional-khor": ExternalTest,
  "rolesYNecesidades-khor": ExternalTest,
  "estiloSocial-khor": ExternalTest,
  "estiloGerencial-khor": ExternalTest,
  "apv-khor": ExternalTest,
  "comprension-khor": ExternalTest,
  "excel-khor": ExternalTest,
  "word-khor": ExternalTest,
  "confiabilidadEspañol-khor": ExternalTest,
  "confiabilidadIngles-khor": ExternalTest,

  "integrity-midot": ExternalTest,
  "integrityAndWork-midot": ExternalTest,

  "typing-worcket": TypingTest,
  "typingEnglish-worcket": TypingTest,
  "successProbability-worcket": SuccessProbabilityTest,
  "identityVerification-worcket": null, // Do not show results here like the other tests
  "reliability-worcket": ReliabilityTest,
  "reliabilityEnglish-worcket": ReliabilityTest,
  "equifax-worcket": null, // Do not show results here like the other tests
  "grammar-worcket": HumanTest,

  english: EnglishTest,
  brainDominance: HumanTest,
  motivationalProfile: HumanTest,
  socialStyle: SocialStyle,
  salesPersonality: HumanTest,
  managerialStyle: HumanTest,
  basicPersonality: HumanTest,
  personality16: HumanTest,
  ivo: IvoTest,
  speed: HumanTest
};

const testProps = {
  salesPersonality: {
    resultsRange: 10
  },
  personality16: {
    resultsRange: 10,
    showOriginalNumber: true
  },
  speed: {
    resultsRange: 5
  }
};

const statuses = {
  locked: "locked",
  purchasing: "purchasing",
  unlocked: "unlocked"
};

function TestDetail({
  test,
  purchased,
  price,
  purchaseTest,
  idOpportunity,
  ...props
}) {
  const initialStatus = purchased ? statuses.unlocked : statuses.locked;
  const [status, setStatus] = useState(initialStatus);
  const { t } = useTranslation(["opportunity"]);
  const TestResult = testResultRenderer[test.type];
  if (!TestResult) return null;

  const unlockTest = async () => {
    try {
      setStatus(statuses.purchasing);
      await purchaseTest(test.idTest);
      setStatus(statuses.unlocked);
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <Panel
      {...props}
      key={test.type}
      header={
        <span data-test={`test-${test.type}`}>
          {t(`opportunity:process.candidateDetails.${test.type}.title`)}
          {test.paid && (
            <Icon
              style={{ marginLeft: 10 }}
              type={status === statuses.unlocked ? "unlock" : "lock"}
            />
          )}
        </span>
      }
    >
      {(status === statuses.locked || status === statuses.purchasing) && (
        <PaymentContainer data-test="payment-locked-test">
          {idOpportunity ? (
            <>
              <p>
                {t("opportunity:process.candidateDetails.buyPremiumTest", {
                  price
                })}
              </p>
              <PaymentSlider onComplete={unlockTest} />
            </>
          ) : (
            t("opportunity:process.candidateDetails.basePremiumTest")
          )}
        </PaymentContainer>
      )}
      {status === statuses.unlocked && (
        <div data-test={`test-result-${test.type}`}>
          <TestResult
            key={test.idTest}
            t={t}
            {...test}
            {...(testProps[test.type] || {})}
          />
        </div>
      )}
    </Panel>
  );
}

export default connect(
  (state, { test: { idTest, paid } }) => ({
    idOpportunity: R.path(["opportunity", "selected", "id"], state),
    purchased:
      !paid ||
      R.find(
        R.pipe(
          R.defaultTo({}),
          R.allPass([
            R.propEq(
              "idCandidate",
              R.path(["candidates", "selected", "id"], state)
            ),
            R.propEq("idTest", idTest),
            R.propEq("article", "test-gh")
          ])
        ),
        FETCH_COMPANY_PURCHASES_LITE.getResponse(state) || []
      ),
    price: R.pipe(
      R.defaultTo([]),
      R.find(R.propEq("idTest", idTest)),
      R.prop("cost")
    )(FETCH_TESTS.getResponse(state))
  }),
  { purchaseTest }
)(TestDetail);
